var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon_wrap",staticStyle:{"cursor":"pointer"},on:{"click":_vm.likeItem}},[_c('div',{staticClass:"like_img",class:{'active': _vm.isMyLike()}}),(_vm.checkLike())?_c('div',{staticClass:"icon_count"},[_vm._v(_vm._s(_vm.likeData.im_like))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }